var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "financeCalculator__form__input financeCalculator__form__input--range",
    },
    [
      _c(
        "button",
        {
          staticClass:
            "financeCalculator__form__rangeTrigger financeCalculator__form__rangeTrigger--decrease",
          on: { click: _vm.onDecrement },
        },
        [
          _c("span", { staticClass: "sr-only" }, [_vm._v("Decrease")]),
          _vm._v("\n        -\n    "),
        ]
      ),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.value,
            expression: "value",
          },
        ],
        ref: "input",
        attrs: {
          type: "number",
          autocomplete: _vm.autocomplete,
          readonly: _vm.readonly,
          disabled: _vm.disabled,
          maxlength: _vm.maxlength,
          min: _vm.min,
          max: _vm.max,
          step: _vm.step,
          id: _vm.id,
        },
        domProps: { value: _vm.value },
        on: {
          blur: function ($event) {
            $event.preventDefault()
            return _vm.onBlur($event)
          },
          keydown: [
            function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])
              ) {
                return null
              }
              $event.preventDefault()
              return _vm.onIncrement($event)
            },
            function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "down", 40, $event.key, [
                  "Down",
                  "ArrowDown",
                ])
              ) {
                return null
              }
              $event.preventDefault()
              return _vm.onDecrement($event)
            },
            function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "space", 32, $event.key, [
                  " ",
                  "Spacebar",
                ])
              ) {
                return null
              }
              $event.preventDefault()
            },
          ],
          input: function ($event) {
            if ($event.target.composing) {
              return
            }
            _vm.value = $event.target.value
          },
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.isEditing,
              expression: "!isEditing",
            },
          ],
          staticClass: "financeCalculator__form__placeholder",
          on: { click: _vm.onPlaceholder },
        },
        [_vm._v("\n        " + _vm._s(_vm.formatter(_vm.value)) + "\n    ")]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass:
            "financeCalculator__form__rangeTrigger financeCalculator__form__rangeTrigger--increase",
          on: { click: _vm.onIncrement },
        },
        [
          _c("span", { staticClass: "sr-only" }, [_vm._v("Increase")]),
          _vm._v("\n        +\n    "),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }